import MainComponent from "./main_component";
import "../../css/master.css";
import { useAtom, atom } from 'jotai';
import Loader from '../../loader/loader';

const isLoadingAtom = atom(false);

function DWPLoginNext() {

    const [isLoading, setIsLoading] = useAtom(isLoadingAtom);

    const handleLoading = (set) => {

        setIsLoading(set)
    }

    return (
        <div>
            {isLoading === true ? <Loader /> : null}
            <MainComponent handleLoading={handleLoading} />
        </div>
    );

}


export default DWPLoginNext;